import { createSelector } from 'reselect';

export const selectMediaSlice = state => state.media;

export const selectMedia = createSelector(
  selectMediaSlice,
  slice => slice.media
);
export const mediaLoaded = createSelector(
  selectMediaSlice,
  slice => slice.mediaLoaded
);
export const selectActiveMedia = createSelector(
  selectMediaSlice,
  slice => slice.activeMedia
);
export const mediaLastEvent = createSelector(
  selectMediaSlice,
  slice => slice.lastUsedEvent
);

export const mediaMeta = createSelector(
  selectMediaSlice,
  slice => slice.meta
);
export const mediaFilters = createSelector(
  selectMediaSlice,
  slice => slice.filters
);

export const mediaCreating = createSelector(
  selectMediaSlice,
  slice => slice.isCreating
);
export const mediaUpdating = createSelector(
  selectMediaSlice,
  slice => slice.isUpdating
);
export const mediaDeleting = createSelector(
  selectMediaSlice,
  slice => slice.isDeleting
);
export const mediaErrors = createSelector(
  selectMediaSlice,
  slice => slice.errors
);
